import React, { Component } from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import ProgressButton from "react-progress-button";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { withMsal } from "@azure/msal-react";
import { ENV_OPTIONS, ROUTES } from "@constants";
import { ADOPERATIONS } from "@constants/index";
import { Tooltip } from "../../../components";

class Security extends Component {
	constructor(props) {
		super(props);

		this.state = {
			changeEmailButtonState: "",
			resetPasswordButtonState: "",
			changeMfaButtonState: "",
			disableMfaButtonState: "",
		};
	}

	updateChangeEmailProgressButton = (value, callback) => {
		this.setState({ changeEmailButtonState: value }, callback);
	};

	updatePasswordResetProgressButton = (value, callback) => {
		this.setState({ resetPasswordButtonState: value }, callback);
	};

	updateMFAProgressButton = (value, callback) => {
		this.setState({ changeMfaButtonState: value }, callback);
	};

	disableMFAProgressButton = (value, callback) => {
		this.setState({ disableMfaButtonState: value }, callback);
	};

	resetPassword = () => {
		const {
			user,
			msalContext: { instance: msalInstance },
		} = this.props;

		this.updatePasswordResetProgressButton("loading");

		msalInstance
			.loginRedirect({
				loginHint: user.Email,
				authority: ENV_OPTIONS.adb2c.policies.resetPassword,
				scopes: ENV_OPTIONS.adb2c.scopes,
				redirectUri: ROUTES.ADCallback,
				state: utils.encodeADState({ operation: ADOPERATIONS.changePassword }),
				extraQueryParameters: {
					uxConfig: utils.encodeADState({ disabledInputs: ["email"] }),
				},
			})
			.finally(() => this.updatePasswordResetProgressButton(""));
	};

	changeEmail = () => {
		const {
			user,
			msalContext: { instance: msalInstance },
		} = this.props;

		this.updateChangeEmailProgressButton("loading");

		msalInstance
			.loginRedirect({
				loginHint: user.Email,
				prompt: "login",
				authority: ENV_OPTIONS.adb2c.policies.changeEmailV2,
				scopes: ENV_OPTIONS.adb2c.scopes,
				redirectUri: ROUTES.ADCallback,
				state: utils.encodeADState({ operation: ADOPERATIONS.changeEmail }),
				extraQueryParameters: {
					uxConfig: utils.encodeADState({ disabledInputs: ["email"] }),
				},
			})
			.finally(() => this.updatePasswordResetProgressButton(""));
	};

	changeMFA = () => {
		const {
			user,
			msalContext: { instance: msalInstance },
		} = this.props;

		this.updateMFAProgressButton("loading");

		msalInstance
			.loginRedirect({
				loginHint: user.Email,
				authority: ENV_OPTIONS.adb2c.policies.editMfa,
				scopes: ENV_OPTIONS.adb2c.scopes,
				redirectUri: ROUTES.ADCallback,
				state: utils.encodeADState({ operation: ADOPERATIONS.editMfa }),
				extraQueryParameters: {
					uxConfig: utils.encodeADState({ disabledInputs: ["email"] }),
				},
			})
			.finally(() => this.updateMFAProgressButton(""));
	};

	disableMFA = () => {
		const {
			user,
			msalContext: { instance: msalInstance },
		} = this.props;

		this.disableMFAProgressButton("loading");

		msalInstance
			.loginRedirect({
				loginHint: user.Email,
				authority: ENV_OPTIONS.adb2c.policies.disableMfa,
				scopes: ENV_OPTIONS.adb2c.scopes,
				redirectUri: ROUTES.ADCallback,
				state: utils.encodeADState({ operation: ADOPERATIONS.disableMfa }),
				extraQueryParameters: {
					uxConfig: utils.encodeADState({ disabledInputs: ["email"] }),
				},
			})
			.finally(() => this.disableMFAProgressButton(""));
	};

	render() {
		const { lang } = global;
		const {
			user,
			msalContext: { instance: msalInstance },
			flags: { federation: federationFlag },
		} = this.props;

		const {
			changeEmailButtonState,
			resetPasswordButtonState,
			changeMfaButtonState,
			disableMfaButtonState,
		} = this.state;

		const isFederated = federationFlag && user.UserAuthenticationPreferences.IsFederated;

		const {
			idTokenClaims: { mfaRequired, strongAuthenticationPhoneNumber },
		} = msalInstance.getAccountByHomeId(localStorage.getItem("homeAccountId"));

		return (
			<div className="my-account-panel">
				<div className="my-account-panel-header">
					<h4 className="title">{lang.t("Account Security Title")}</h4>
				</div>
				<div className="my-account-panel-body security-body">
					<If condition={federationFlag}>
						<div className="row">
							<div className="col-xs-12 col-sm-8 text-left">
								{lang.t("Account Security Change Email Text")}
							</div>
							<div className="col-xs-12 col-sm-4 text-right security-buttons">
								<Choose>
									<When condition={isFederated}>
										<ProgressButton
											id="change-email-ad"
											className="btn btn-primary btn-medium"
											state="disabled"
										>
											{lang.t("Change")}
										</ProgressButton>
									</When>
									<Otherwise>
										<ProgressButton
											id="change-email-ad"
											className="btn btn-primary btn-medium"
											state={changeEmailButtonState}
											onClick={this.changeEmail}
										>
											{lang.t("Change")}
										</ProgressButton>
									</Otherwise>
								</Choose>
							</div>
						</div>
					</If>
					<div className="row">
						<div className="col-xs-12 col-sm-8 text-left">
							{lang.t("Account Security MFA Text")}
							<Tooltip content={lang.t("Account Security MFA Tooltip")}>
								<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
							</Tooltip>
							<Choose>
								<When
									condition={
										!isFederated &&
										mfaRequired &&
										strongAuthenticationPhoneNumber &&
										strongAuthenticationPhoneNumber !== ""
									}
								>
									<p>{strongAuthenticationPhoneNumber}</p>
								</When>
							</Choose>
						</div>
						<div className="col-xs-12 col-sm-4 text-right security-buttons">
							<Choose>
								<When condition={isFederated}>
									<ProgressButton
										id="mfa-ad-change"
										className="btn btn-primary btn-medium"
										state="disabled"
									>
										{lang.t("Change")}
									</ProgressButton>
								</When>
								<When condition={mfaRequired}>
									<ProgressButton
										id="mfa-ad-disable"
										className="btn btn-primary btn-medium"
										state={disableMfaButtonState}
										onClick={this.disableMFA}
									>
										{lang.t("Disable")}
									</ProgressButton>
									<ProgressButton
										id="mfa-ad-change"
										className="btn btn-primary btn-medium"
										state={changeMfaButtonState}
										onClick={this.changeMFA}
									>
										{lang.t("Change")}
									</ProgressButton>
								</When>
								<Otherwise>
									<ProgressButton
										id="mfa-ad-enable"
										className="btn btn-primary btn-medium"
										state={changeMfaButtonState}
										onClick={this.changeMFA}
									>
										{lang.t("Enable")}
									</ProgressButton>
								</Otherwise>
							</Choose>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12 col-sm-6 text-left">
							{lang.t("Account Security Password Text")}
						</div>
						<div className="col-xs-12 col-sm-6 text-right security-buttons">
							<Choose>
								<When condition={isFederated}>
									<ProgressButton
										id="reset-password-ad"
										className="btn btn-primary btn-medium"
										state="disabled"
									>
										{lang.t("Change")}
									</ProgressButton>
								</When>
								<Otherwise>
									<ProgressButton
										id="reset-password-ad"
										className="btn btn-primary btn-medium"
										state={resetPasswordButtonState}
										onClick={this.resetPassword}
									>
										{lang.t("Change")}
									</ProgressButton>
								</Otherwise>
							</Choose>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Security.propTypes = {
	user: PropTypes.object,
	msalContext: PropTypes.object.isRequired,
	flags: PropTypes.object.isRequired,
};

Security.defaultProps = {
	user: {},
};

export default withLDConsumer()(withMsal(Security));
